/**
 * Which ledger an audit event came from. The `AuditEvents/Search` feed is a union of two
 * ledgers, and a row's category determines which fields are populated (disclosures carry
 * patient/MRN; admin actions carry a target entity) and whether a detail drill-down exists.
 * Mirrors the API `AuditEventCategory` (persisted `byte` values — do not renumber).
 */
export enum AuditEventCategory {
  /** A patient-data disclosure; has a disclosure-detail drill-down. */
  PatientDataDisclosure = 1,
  /** A staff/admin action against a portal entity; no disclosure-detail page. */
  AdminAction = 2,
}
